import React from 'react';
import classNames from 'classnames';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function CloseButton({
  onClick,
  className = '',
  label = 'Close',
  size = 'md',
}) {
  const iconSize = size === 'sm' ? 'h-5 w-5' : 'h-6 w-6';

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={classNames(
        'rounded-md text-gray-400 transition hover:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 cursor-pointer',
        className
      )}
    >
      <span className="sr-only">{label}</span>
      <XMarkIcon className={iconSize} aria-hidden="true" />
    </button>
  );
}
